import { render, staticRenderFns } from "./contentCourseLiveDelete.vue?vue&type=template&id=2f9bfbb0&"
import script from "./contentCourseLiveDelete.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports